export const EXTRA_CHART_COLOURS = ['#78A1BB', '#192A51', '#FABC2A'];
